import angular from 'angular';
import { TimeZoneService } from './TimeZoneService';

angular.module('sh.timeZone', []).service('TimeZone', TimeZoneService);
